module.exports = __webpack_public_path__ + "static/assets/22807fb96996621e3222c326efb46398.png";